import type { TermsOption } from "@stripe/stripe-js";
import { useMemo } from "react";

export const usePaymentElementTerms = (): TermsOption =>
  useMemo(
    () => ({
      card: "never",
      googlePay: "never",
      applePay: "never",
    }),
    [],
  );
